import { useLingui } from '@lingui/react/macro';
import type {
  ColorAndContrastSetting,
  NavigationSetting,
  TextAndReadabilitySetting,
  WidgetPage
} from '../../types';
import { Page } from '../components/page';
import { SettingBlock } from '../components/setting-block';
import { useSettingsData } from '../data/use-settings-data';

export function Settings({ onCloseRequest }: WidgetPage) {
  const { t } = useLingui();
  const {
    textAndReadabilitySettings,
    navigationSettings,
    colorAndContrastSettings
  } = useSettingsData();

  return (
    <Page
      title={t`Accessibility Settings`}
      onCloseRequest={onCloseRequest}
      showBack
    >
      <SettingBlock<TextAndReadabilitySetting>
        data={textAndReadabilitySettings}
        title={t`Text & Readability`}
        type="switch"
      />
      <SettingBlock<NavigationSetting>
        data={navigationSettings}
        title={t`Navigation`}
        type="switch"
      />
      <SettingBlock<ColorAndContrastSetting>
        data={colorAndContrastSettings}
        title={t`Color & Contrast`}
        type="radio"
        radioSettingName="colorsContrast"
      />
    </Page>
  );
}
